import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect } from 'react'

import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import PodcastPage from './pages/PodcastPage'
import ArticlesPage from './pages/ArticlesPage'
import BlogPostPage from './pages/BlogPostPage'

// Page transition variants
const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: 'easeIn',
    },
  },
}

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default function App() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Navbar />
      
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/podcast" element={<PodcastPage />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
      
      <Footer />
    </div>
  )
}
